import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
export const Tags = (param)=>{
    let { items, className, label = 'Onderwerpen', limit } = param;
    const visible = limit ? items === null || items === void 0 ? void 0 : items.slice(0, limit) : items;
    if (!(visible === null || visible === void 0 ? void 0 : visible.length)) return null;
    return /*#__PURE__*/ _jsxs("div", {
        className: `${className} tags`,
        children: [
            /*#__PURE__*/ _jsxs("span", {
                className: "sr-text",
                children: [
                    label,
                    ": "
                ]
            }),
            /*#__PURE__*/ _jsx("ul", {
                className: "tags__list",
                children: visible.map((item, i)=>/*#__PURE__*/ _jsx("li", {
                        className: "tags__item",
                        children: /*#__PURE__*/ _jsx("span", {
                            className: "tags__tag",
                            children: item
                        })
                    }, `tag-${i}-${item}`))
            })
        ]
    });
};
